export default __webpack_public_path__ + "static/media/color-picker-svg.1490284f.svg";